import Button from "../UI-components/Button";

const PdfAreaTableRow = ({
  date,
  username,
  exportType,
  status,
  progress,
  pdfUrl,
  onShowResponseClick,
  user
}) => {
  return (
    <tr>
      <td>
        {Intl.DateTimeFormat("it", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        }).format(date)}
      </td>
      <td>{username}</td>
      <td>{exportType}</td>
      <td>{status}</td>
      <td>{progress ? `${progress}%` : "-"}</td>
      <td>
        {pdfUrl ? (
          <Button handleClick={() => onShowResponseClick(pdfUrl+(user? "?userId="+user.user_name:""))}>
            DOWNLOAD
          </Button>
        ) : (
          "-"
        )}
      </td>
    </tr>
  );
};

export default PdfAreaTableRow;
